import { GET_ORDER_AGENDAS } from "../../graphql/query/Agenda";
import { GET_ORDERS_AGING, GET_ORDER_AGIGN } from "../../graphql/query/OrderAging";
import { GET_TICKET_AGING } from "../../graphql/query/TicketAging";
import { GraphqlService, ObservableQueryT } from "../../services/graphql.service";
import { GET_TADATA_STARTED, GET_TADATA_SUCCESS, GET_TADATA_ERROR, GET_TICKETS_AGING_STARTED, GET_TICKETS_AGING_SUCCESS, GET_TICKETS_AGING_ERROR } from "../types/ticketAging.type";


let agingDataQuery: ObservableQueryT;
let agignTicketsQuery: ObservableQueryT;

export function getTAgingDataAction() {
    return async dispatch => {
        dispatch(getAgingDataStarted());
        try {
            let data = await GraphqlService.SendQuery(GET_TICKET_AGING);
            
            delete data.__typename;
            Object.keys(data).forEach(key => {
                delete data[key][0].__typename;
            })
            
            dispatch(getAgingDataSuccess(data));
        } catch (ex) {
            dispatch(getAgingDataError(ex.message));
        }
    }
}

const getAgingDataStarted = () => ({type: GET_TADATA_STARTED});
const getAgingDataSuccess = data => ({type: GET_TADATA_SUCCESS, payload: data});
const getAgingDataError = error => ({type: GET_TADATA_ERROR, payload: error});


export function getAgingTicketsAction(aging) {
    return async dispatch => {
        let ids = !aging || (aging?.count || 0) == 0 ? [-1] : aging.ids;

        dispatch(getAgingOrdersStarted(aging));
        try {
            dispatch(getAgingOrdersSuccess(await GraphqlService.SendQuery(GET_ORDER_AGENDAS, {ids})));
        } catch (ex) {
            dispatch(getAgingOrdersError(ex.message));
        }
        
    }
}

const getAgingOrdersStarted = (data) => ({type: GET_TICKETS_AGING_STARTED, payload: data});
const getAgingOrdersSuccess = data => ({type: GET_TICKETS_AGING_SUCCESS, payload: data});
const getAgingOrdersError = error => ({type: GET_TICKETS_AGING_ERROR, payload: error});
